export default __webpack_public_path__ + "static/media/22.1e149fc0.png";